<template>
  <svg width="8" height="24" viewBox="0 0 8 14" fill="#9FA1AA" xmlns="http://www.w3.org/2000/svg"><path d="M0.555466 2.67774L4.83238 6.99996L0.555466 11.3222C0.278542 11.602 0.17039 12.0099 0.271752 12.3922C0.373113 12.7745 0.668588 13.0731 1.04687 13.1756C1.42516 13.278 1.82879 13.1687 2.10571 12.8888L7.15225 7.78885C7.3581 7.58124 7.47379 7.29941 7.47379 7.00552C7.47379 6.71162 7.3581 6.42979 7.15225 6.22218L2.10571 1.11107C1.90028 0.903039 1.62141 0.786133 1.33059 0.786133C1.03977 0.786133 0.760895 0.903039 0.555466 1.11107C0.13767 1.5444 0.13767 2.25552 0.555466 2.67774Z" fill="#9FA1AA"></path></svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
